module.exports = __webpack_public_path__ + "img/76.49c5ca3d.jpg";